module.exports = __webpack_public_path__ + "img/andy_kitchen.da34669e.png";